import React from 'react';
import { User } from 'lucide-react';
import { SocialIcon } from '../icons/SocialIcon';
import type { SocialPlatform } from '../icons/SocialIcon';
import tiktokIcon from '../../assets/logos/tiktok.svg';

interface SocialProfilePictureProps {
  pictureUrl?: string;
  username: string;
  platform: SocialPlatform;
  size?: 'sm' | 'md' | 'lg';
}

export const SocialProfilePicture: React.FC<SocialProfilePictureProps> = ({ 
  pictureUrl, 
  username, 
  platform,
  size = 'md'
}) => {
  // Map size to dimensions
  const dimensions = {
    sm: {
      container: 'w-8 h-8',
      badge: 'w-3 h-3 translate-y-1/2 bottom-0 -right-0.5 p-0.5',
      icon: 10
    },
    md: {
      container: 'w-10 h-10',
      badge: 'w-4 h-4 translate-y-1/2 bottom-0 -right-1 p-0.5',
      icon: 14
    },
    lg: {
      container: 'w-12 h-12',
      badge: 'w-5 h-5 translate-y-1/2 bottom-0 -right-1 p-0.5',
      icon: 16
    }
  };

  const { container, badge, icon } = dimensions[size];

  // Special handling for TikTok logo
  const renderBadge = () => {
    if (platform === 'tiktok') {
      return (
        <div className={`absolute ${badge} bg-white rounded-lg border border-black flex items-center justify-center`}>
          <img src={tiktokIcon} alt="TikTok" className="w-full h-full" />
        </div>
      );
    }
    
    return (
      <div className={`absolute ${badge} bg-white rounded-lg border border-black flex items-center justify-center`}>
        <SocialIcon platform={platform} size={icon} />
      </div>
    );
  };

  return (
    <div className="relative">
      {pictureUrl ? (
        <img 
          src={pictureUrl} 
          alt={username}
          className={`${container} rounded-lg object-cover border border-black`}
        />
      ) : (
        <div className={`${container} bg-gray-100 rounded-lg flex items-center justify-center border border-black`}>
          <User className="w-3/4 h-3/4 text-gray-400" />
        </div>
      )}
      {renderBadge()}
    </div>
  );
}; 